import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomDrawer from "../GeneralComponents/CustomDrawer";
import AddOrUpdateReport from "./AddOrUpdateReport";
import { useContentSetting } from "../../Hooks/ContentSetting";
import { getStudentProgressRecordNounTitleKey } from "../../utils/associateCapabilities";
import { emitReportListEvent } from "../../utils/reportListEvents";
import AddIcon from "@mui/icons-material/Add";
import useMediaQuery from "@mui/material/useMediaQuery";

const EMPTY_REPORT = Object.freeze({});
const EMPTY_LIST = Object.freeze([]);

export default function AddReportHeader() {
  const { t } = useTranslation();
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const { userInfo } = useContentSetting();
  const addTitle = t("progress.addWithNoun", { noun: t(getStudentProgressRecordNounTitleKey(userInfo)) });
  const isMobile = useMediaQuery("(max-width: 767px)");

  const handleOpenDrawer = () => {
    setIsOpenDrawer(true);
  };

  const handleCloseDrawer = () => {
    setIsOpenDrawer(false);
  };

  const setReportsList = useCallback((updater) => {
    const next = typeof updater === "function" ? updater([]) : updater;
    if (Array.isArray(next) && next[0]) {
      emitReportListEvent({ type: "created", report: next[0] });
    }
  }, []);

  return (
    <>
      {isMobile ? (
        <div
          className="header-button-action add-report-header-mobile"
          onClick={handleOpenDrawer}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleOpenDrawer(); } }}
          aria-label={addTitle}
        >
          <AddIcon sx={{ fontSize: 20 }} />
        </div>
      ) : (
        <div className="add--button">
          <button onClick={handleOpenDrawer} style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
            <AddIcon sx={{ fontSize: 20 }} />
            {addTitle}
          </button>
        </div>
      )}
      <CustomDrawer
        isOpenDrawer={isOpenDrawer}
        onOpenDrawer={handleOpenDrawer}
        onCloseDrawer={handleCloseDrawer}
        pageTitle={addTitle}
        componentToPassDown={
          <AddOrUpdateReport
            formType={"ADD"}
            onCloseDrawer={handleCloseDrawer}
            reportsList={EMPTY_LIST}
            setReportsList={setReportsList}
            selectedObject={EMPTY_REPORT}
          />
        }
      />
    </>
  );
}
